"use client";
import { Image } from "@/components/shared/image";
import { useInView } from "framer-motion";
import { useEffect, useRef, useState } from "react";

export function VideoComponent({
  isPlaying,
  thumbnail,
  videoUrl,
}: {
  isPlaying: boolean;
  thumbnail: string;
  videoUrl: string;
}) {
  const playerRef = useRef<any>(null);
  const [_, setIsVideoLoaded] = useState(false);
  const inview = useInView(playerRef, {
    amount: 0.6,
  });

  useEffect(() => {
    if (!inview && isPlaying) {
      const video = playerRef.current;
      if (!video) return;

      video.pause();
    }
  }, [inview, isPlaying]);

  useEffect(() => {
    if (isPlaying) {
      playerRef.current?.play();
    } else {
      playerRef.current?.pause();
    }
  }, [isPlaying]);

  useEffect(() => {
    const videoElement = playerRef.current;

    if (!videoElement) return;

    const handleLoadedData = () => {
      setIsVideoLoaded(true);
    };

    playerRef.current.src = videoUrl;

    playerRef.current.preload = "metadata";
    videoElement.addEventListener("loadeddata", handleLoadedData);

    return () => {
      videoElement.removeEventListener("loadeddata", handleLoadedData);
    };
  }, []);

  return (
    <div className="relative h-full w-full">
      {!isPlaying && (
        <div className="absolute inset-0 z-20 rounded-[40px]">
          <Image
            src={thumbnail}
            alt=""
            fill
            className="rounded-[40px] object-cover"
          />
        </div>
      )}
      <video
        ref={playerRef}
        playsInline
        preload="auto"
        className="rounded-[40px]"
        controls={true}
        autoPlay={false}
        poster={thumbnail}
        src={videoUrl}
      >
        {/* <source type="video/mp4" /> */}
      </video>
    </div>
  );
}
